"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class AddressServiceLive {
    async getPostcodeData(postcode) {
        const response = await HttpProvider_1.httpProvider.get(`/address/${postcode}`);
        return response.data;
    }
}
exports.AddressServiceLive = AddressServiceLive;
//# sourceMappingURL=AddressServiceLive.js.map